import {inject} from "@angular/core";
import {OnlinePaymentChecker} from "../components/utils/online-payment-checker";
import {NavigationCommand, NavigationService} from "../../data/services/navigation.service";
import {PaymentService} from "../../data/services/payment.service";
import {CanActivateFn} from "@angular/router";
import {ConfigService} from "../services/config.service";

export const EditPaymentGuard: CanActivateFn = (route, state) => {
  const paymentService = inject(PaymentService);
  const onlinePaymentChecker: OnlinePaymentChecker = new OnlinePaymentChecker();
  const navigationService = inject(NavigationService);
  const configService = inject(ConfigService);

  const paymentWebId = route.paramMap.get('paymentWebId');
  const paymentBackendId = route.paramMap.get('paymentBackendId');

  if (paymentWebId && paymentBackendId) {
    configService.loadConfig(onlinePaymentChecker.ONLINE_PAYMENT_METHOD_ID_CONFIG_KEY).subscribe(
      (_config) => {
        if (_config && _config.value) {
          onlinePaymentChecker.setPaymentCode(_config.value);
          paymentService.getPayment(paymentWebId, paymentBackendId).subscribe(
            ($payment) => {
              if ($payment && onlinePaymentChecker.isOnlinePayment($payment)) {
                navigationService.navigateTo(NavigationCommand.PAYMENT);
                return false;
              }
            });
        }
      });
  }
  return true;
}
